const DEFAULT_LOCALE = 'en';

export const formatCurrency = (
  value: number,
  currencyUnit: string | null,
  options?: Intl.NumberFormatOptions,
): string => {
  if (!currencyUnit) {
    return value?.toString();
  }

  try {
    return new Intl.NumberFormat(DEFAULT_LOCALE, {
      ...options,
      style: 'currency',
      currency: currencyUnit.toUpperCase(),
    }).format(value);
  } catch (_) {
    return `${value} ${currencyUnit}`;
  }
};

export const formatCompactCurrency = (value: number, currencyUnit: string | null): string =>
  formatCurrency(value, currencyUnit, {
    notation: 'compact',
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  });

export const getCurrencySymbol = (currencyCode: string | null): string => {
  if (!currencyCode) return '$';

  try {
    const formatted = new Intl.NumberFormat(DEFAULT_LOCALE, {
      style: 'currency',
      currency: currencyCode.toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(0);

    return formatted.replace(/[\d,.\s]/g, '');
  } catch {
    return currencyCode;
  }
};

export const getCurrencyLabel = (currencyCode: string | null): string | null => {
  if (!currencyCode) return null;

  const normalizedCode = currencyCode.toUpperCase();
  return `${normalizedCode} (${getCurrencySymbol(normalizedCode)})`;
};
